import { render, staticRenderFns } from "./TeacherSalaryConfig.vue?vue&type=template&id=5001edc8"
import script from "./TeacherSalaryConfig.vue?vue&type=script&lang=js"
export * from "./TeacherSalaryConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports